import EleSimilarHouseholds from "@/components/Budget/EleSimilarHouseholds";
import Footer from "@/components/footer/footer";
import { useConfig } from "@/context/use-context";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AnnualExpenses from "../../components/Budget/AnnualExpenses";
import BaseAnnualExpense from "../../components/Budget/BaseAnnualExpense";
import BaseBreakdownChart from "../../components/Budget/BaseBreakdownChart";
import BgtComparisonChart from "../../components/Budget/BgtComparisonChart";
import BudgetSummary from "../../components/Budget/BudgetSummary";
import CostBreakdownChart from "../../components/Budget/CostBreakdownChart";

const Budget = () => {
	const navigate = useNavigate();
	const { pod } = useConfig();

	return (
		<div className="px-2 py-4 mb-20 mt-10">
			<div className="max-w-md mx-auto p-2">
				<div className="flex justify-between items-center mb-4">
					<h1 className="text-xl font-bold text-gray-800">Mes dépenses</h1>
					<button
						type="button"
						className="text-gray-600 hover:text-gray-800 transition"
						onClick={() => navigate("/setting")}
					>
						<FiSettings className="w-6 h-6" />
					</button>
				</div>
			</div>
			<div className="max-w-md mx-auto px-2 space-y-4">
				<BudgetSummary />

				{pod?.pricing_option === "BASE" ? (
					<>
						<BaseBreakdownChart />
						<BaseAnnualExpense />
					</>
				) : (
					<>
						<CostBreakdownChart />
						<AnnualExpenses />
					</>
				)}

				<BgtComparisonChart />
				<EleSimilarHouseholds />
				<Footer />
			</div>
		</div>
	);
};

export default Budget;
